import React, { createContext, useContext, useState, ReactNode } from 'react'

interface ResourcesSearchContextType {
  search: string
  setSearch: (value: string) => void
}

const ResourcesSearchContext = createContext<ResourcesSearchContextType | undefined>(undefined)

export const useResourcesSearch = () => {
  const context = useContext(ResourcesSearchContext)
  if (!context) {
    throw new Error('useResourcesSearch must be used within a ResourcesSearchProvider')
  }
  return context
}

export const ResourcesSearchProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [search, setSearch] = useState('')
  return (
    <ResourcesSearchContext.Provider value={{ search, setSearch }}>
      {children}
    </ResourcesSearchContext.Provider>
  )
} 